import { render, staticRenderFns } from "./recordPayment.vue?vue&type=template&id=1ddd6140&scoped=true&"
import script from "./recordPayment.vue?vue&type=script&lang=js&"
export * from "./recordPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddd6140",
  null
  
)

export default component.exports